<template>
  <footer>
    <p>&copy; 2025 IT Support Duda. All rights reserved.</p>
    <p>Kontaktiere uns: support@duda.com</p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'  // Updated name
};
</script>

<style scoped>
footer {
  background-color: #0000008a;
  color: white;
  text-align: center;
  padding: 1rem;
  margin-top: 0rem;
}

footer p {
  margin: 0.5rem 0;
}
</style>
